import { z } from "zod";

export const GlobalFormSchema = z.object({
  whatsapp: z.string({ required_error: "Whatsapp diperlukan agar dapat menghubungi Anda nantinya." }),
  message: z.string({ required_error: "Pesan wajib diisi" })
});
